
export interface ItemRequestResultModalState {
  show: boolean
  style: ModalStyle
  heading: string
  messages: string[]
  onClose?: () => void
}

export const itemRequestResultModalInitialState: ItemRequestResultModalState = {
  show: false,
  style: 'success',
  heading: '',
  messages: [],
}

export type ModalStyle = 'success' | 'error'

export class ItemRequestResultModalEventHandler {
  /**
   * モーダルを表示するAjaxコンポーネントが分かれているが、
   * モーダル自体はひとつしか表示したくないのでsingletonなステートを変更する方針を取った
   */
  static getInstance(): ItemRequestResultModalEventHandler {
    if (!ItemRequestResultModalEventHandler.instance) {
      ItemRequestResultModalEventHandler.instance = ItemRequestResultModalEventHandler.initialize()
    }

    return ItemRequestResultModalEventHandler.instance
  }

  private static instance: ItemRequestResultModalEventHandler | null = null

  private static initialize(): ItemRequestResultModalEventHandler {
    return new ItemRequestResultModalEventHandler(
      []
    )
  }

  private constructor(
    private _eventHandlers: Array<(state: ItemRequestResultModalState) => void>
  ) {}

  addEventListener(callback: (state: ItemRequestResultModalState) => void) {
    this._eventHandlers.push(callback)
  }

  open(params: Omit<ItemRequestResultModalState, 'show'>): void {
    this.emit({
      show: true,
      ...params,
    })
  }

  close(): void {
    this.emit(itemRequestResultModalInitialState)
  }

  private emit(state: ItemRequestResultModalState): void {
    this._eventHandlers.map(c => c(state))
  }
}
